import React, { useEffect, useState } from 'react';
import './style.css';
// import Grid from '@mui/material/Grid';
import CssBaseline from '@mui/material/CssBaseline';
import { ToastContainer } from 'react-toastify';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import 'react-toastify/dist/ReactToastify.css';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import PriceManagemantDescriptions from './price-management-descriptions';
import PriceManagemantAddEdit from './price-management-add-edit';


const theme = createTheme();

function PriceManagemant(props) {
  const [value, setValue] = useState('1');
  // const [priceType, setPriceType] = useState('Now')

  useEffect(() => {
    // getCompanyList();
  }, [props]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className='mainAppDiv'>

      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ToastContainer />
        <Typography className='AdminAddEmployerHeadding'>
          Pricing Management
        </Typography>

        <Box sx={{ width: '100%', typography: 'body1' }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className='confogTabTopRow'>
              <TabList onChange={handleChange} aria-label="lab API tabs example">
                <Tab label="Transfer Now" value="1" className='textTransformDefault' />
                <Tab label="Transfer Next Day" value="2" className='textTransformDefault' />

              </TabList>
            </Box>
            <TabPanel value="1" className=''>
              <PriceManagemantDescriptions />
              <PriceManagemantAddEdit priceType={'Now'} />
            </TabPanel>
            <TabPanel value="2" className=''>
              <PriceManagemantDescriptions />
              <PriceManagemantAddEdit priceType={'Next'} />
            </TabPanel>
          </TabContext>
        </Box>

      </ThemeProvider>
    </div>

  );
}

export default PriceManagemant;